import { render } from "./CalendarContent.vue?vue&type=template&id=fd65b9d4"
import script from "./CalendarContent.vue?vue&type=script&lang=js"
export * from "./CalendarContent.vue?vue&type=script&lang=js"

import "./CalendarContent.vue?vue&type=style&index=0&id=fd65b9d4&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__